import { render, staticRenderFns } from "./articleContent.vue?vue&type=template&id=2c76a1c8&scoped=true"
import script from "./articleContent.vue?vue&type=script&lang=ts"
export * from "./articleContent.vue?vue&type=script&lang=ts"
import style0 from "./articleContent.vue?vue&type=style&index=0&id=2c76a1c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76a1c8",
  null
  
)

export default component.exports